var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdministrator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m236.25 323.75c0 14.496-11.754 26.25-26.25 26.25s-26.25-11.754-26.25-26.25 11.754-26.25 26.25-26.25 26.25 11.754 26.25 26.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m516.25 166.12c-29.277-1.2773-56.789-12.348-78.75-31.633-21.961 19.285-49.473 30.355-78.75 31.633v61.383c0 43.426 35.324 78.75 78.75 78.75s78.75-35.324 78.75-78.75zm-122.5 35.133c-4.8281 0-8.75-3.9219-8.75-8.75s3.9219-8.75 8.75-8.75 8.75 3.9219 8.75 8.75-3.9219 8.75-8.75 8.75zm43.75 78.75c-19.301 0-35-15.699-35-35h17.5c0 9.6523 7.8477 17.5 17.5 17.5s17.5-7.8477 17.5-17.5h17.5c0 19.301-15.699 35-35 35zm43.75-78.75c-4.8281 0-8.75-3.9219-8.75-8.75s3.9219-8.75 8.75-8.75 8.75 3.9219 8.75 8.75-3.9219 8.75-8.75 8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.25 148.75h11.75c29.582 0 57.398-11.516 78.312-32.438l6.1875-6.1836 6.1875 6.1875c20.922 20.918 48.727 32.434 78.312 32.434h11.75v18.383c6.5 1.3281 12.391 4.2188 17.5 8.0859v-60.609c0-21.691-15.445-40.531-36.715-44.781l-2.5977-0.52344-13.004-13.004c-19.383-19.375-45.16-30.051-72.562-30.051-56.586 0-102.62 46.035-102.62 102.62v46.359c5.1094-3.8672 11-6.7656 17.5-8.0859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.5 328.88v-11.812c-10.867 4.2617-22.645 6.6836-35 6.6836s-24.133-2.4219-35-6.6836v11.812l35 35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m513.2 352.37-29.582-9.8594-33.742 33.738 29.785 29.785z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.81 345.51c0.42969 1.1289 0.875 2.2227 1.3477 3.3086l1.6992 3.7891-9.4609 18.914 15.828 15.828 18.918-9.457 3.7891 1.6992c1.0859 0.48047 2.1797 0.91797 3.3086 1.3477l3.875 1.4688 6.6953 20.09h22.391l6.6953-20.09 3.875-1.4688c1.1289-0.42969 2.2227-0.875 3.3086-1.3477l3.7891-1.6992 18.918 9.457 15.828-15.828-9.457-18.918 1.6992-3.7891c0.48047-1.0859 0.91797-2.1797 1.3477-3.3086l1.4688-3.875 20.078-6.6914v-22.391l-20.09-6.6953-1.4688-3.875c-0.42969-1.1289-0.875-2.2227-1.3477-3.3086l-1.6992-3.7891 9.457-18.918-15.828-15.828-18.918 9.457-3.7891-1.6992c-1.0859-0.48047-2.1797-0.91797-3.3086-1.3477l-3.875-1.4688-6.6914-20.078h-22.391l-6.6953 20.09-3.875 1.4688c-1.1289 0.42969-2.2227 0.875-3.3086 1.3477l-3.7891 1.6992-18.918-9.457-15.82 15.828 9.457 18.918-1.6992 3.7891c-0.48047 1.0859-0.91797 2.1797-1.3477 3.3086l-1.4688 3.875-20.086 6.6914v22.391l20.09 6.6953zm57.191-65.512c24.125 0 43.75 19.625 43.75 43.75s-19.625 43.75-43.75 43.75-43.75-19.625-43.75-43.75 19.625-43.75 43.75-43.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.8 352.37 33.547 53.664 29.785-29.785-33.742-33.738z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.59 437.5-6.2461 43.75h32.32l-6.2461-43.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.26 404.86 5.0469 15.137h22.383l5.0469-15.137-16.238-16.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m533.75 227.5c0 2.4492-0.18359 4.8477-0.36719 7.2539 10.352-3.5195 17.867-13.23 17.867-24.754 0-11.391-7.3398-21.016-17.5-24.641z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m573.83 372.58-43.559-14.516-47.434 75.898-15.27-15.27-3.6133 10.859 7.3867 51.695h132.41v-67.164c0-18.855-12.023-35.535-29.918-41.504z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245 498.75h-70v17.5h-17.5v17.5h105v-17.5h-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.16 433.96-47.434-75.898-3.4727 1.1562v122.03h62.406l7.3906-51.695-3.6211-10.859z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315 332.5h-8.75v15.059l-21.488 7.1562 10.133 20.258-33.672 33.672-20.258-10.133-7.1562 21.488h-47.609l-7.1562-21.488-20.258 10.133-33.672-33.672 10.133-20.258-21.496-7.1562v-15.059h-8.75c-4.8281 0-8.75 3.9219-8.75 8.75v105h227.5v-105c0-4.8281-3.9219-8.75-8.75-8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.25 472.5c0 4.8281 3.9219 8.75 8.75 8.75h210c4.8281 0 8.75-3.9219 8.75-8.75v-8.75h-227.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.25 227.5v-42.141c-10.16 3.6211-17.5 13.246-17.5 24.641 0 11.523 7.5156 21.234 17.867 24.754-0.18359-2.4062-0.36719-4.8047-0.36719-7.2539z"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 691.25,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 102.109375,
    y: 691.25,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.683594,
    y: 691.25,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 153.355469,
    y: 691.25,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 182.878906,
    y: 691.25,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 203.792969,
    y: 691.25,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 233.464844,
    y: 691.25,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 280.011719,
    y: 691.25,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 311.328125,
    y: 691.25,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 355.078125,
    y: 691.25,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 384.964844,
    y: 691.25,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 416.113281,
    y: 691.25,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 442.046875,
    y: 691.25,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 471.570312,
    y: 691.25,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 486.566406,
    y: 691.25,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 515.082031,
    y: 691.25,
    xlinkHref: "#i"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrator);
export default __webpack_public_path__ + "static/media/administrator.be2a7a1caae9acbd1365bd169966139f.svg";
export { ForwardRef as ReactComponent };